export type ReviewRequest = {
  id: number;
  token: string;
  source: string;
  status: string;
  email: string;
  customer_name: string;
  customer_first_name: string;
  remote_order_id: string;
  order_number: string;
  shipping_country: string;
  scheduled_for: string | null;
  sent_at: string | null;
  reminder_sent_at: string | null;
  reviewed: boolean;
  review_line_items?: ReviewLineItem[];
  created_at: string;
  updated_at: string;
};

export type ReviewLineItem = {
  id: number;
  title: string;
  image_url: string;
  quantity: number;
  price: number;
  sku: string;
  remote_product_id: string;
  remote_variant_id: string;
};

export type CreateReviewRequest = Pick<
  ReviewRequest,
  | "email"
  | "source"
  | "customer_name"
  | "customer_first_name"
  | "remote_order_id"
  | "order_number"
  | "shipping_country"
  | "scheduled_for"
>;

export const SOURCE_OPTIONS = [
  { value: "JAPAN_HAUL", label: "Japan Haul" },
  { value: "SC_MINI_MARKET", label: "SC Mini Market" },
  { value: "TT_MINI_MARKET", label: "TT Mini Market" },
  { value: "ICHIGO_APP", label: "Ichigo App" },
];

export const SOURCE_COLORS: Record<string, string> = {
  JAPAN_HAUL: "blue",
  SC_MINI_MARKET: "grape",
  TT_MINI_MARKET: "teal",
  ICHIGO_APP: "orange",
};

export const SOURCE_LABELS: Record<string, string> = {
  JAPAN_HAUL: "Japan Haul",
  SC_MINI_MARKET: "SC Mini Market",
  TT_MINI_MARKET: "TT Mini Market",
  ICHIGO_APP: "Ichigo App",
};

export const STATUS_OPTIONS = [
  { value: "scheduled", label: "Scheduled" },
  { value: "sent", label: "Sent" },
  { value: "failed", label: "Failed" },
];

export const STATUS_COLORS: Record<string, string> = {
  scheduled: "blue",
  sent: "green",
  failed: "red",
};

export const STATUS_LABELS: Record<string, string> = {
  scheduled: "Scheduled",
  sent: "Sent",
  failed: "Failed",
};
